import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import get from 'lodash/get';
import getImageUrl from '@configuratorware/configurator-frontendgui/App/Utils/getImageUrl';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  designsContainer: {
    width: 300,
    visibility: 'visible',
    maxHeight: '100%',
    overflow: 'auto',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      width: 'min(200px, 18vw)',
      overflow: 'visible',
    },
    [theme.breakpoints.down('xs')]: {
      position: 'absolute',
      top: 0,
    },
  },
  hide: {
    visibility: 'hidden',
  },
  titleLabel: {
    fontWeight: 'bold',
  },
  loader: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ffffff',
    height: '100%',
    width: '100%',
  },
  design: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'hidden',
    flex: 1,
    maxHeight: 300,

    '&:first-child': {
      paddingBottom: 20,
    },
    '& img': {
      width: 'auto',
      height: 300,
      [theme.breakpoints.down('sm')]: {
        height: 200,
      },
    },
  },
  image: {
    flex: 1,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    width: '100%',
  },
}));

export const Designs = ({ otherDesigns }) => {
  const { selectedDesign, configuration } = useSelector((state) => state.configurator);
  const { selectedDesignView } = useSelector((state) => state.designView);
  const { loadVisualization } = useSelector((state) => state.ui.visibilityMap);
  const classes = useStyles();
  const viewImages = get(configuration, 'visualizationData.viewImages');

  return (
    <div className={clsx(classes.designsContainer, loadVisualization && classes.hide)}>
      {viewImages &&
        otherDesigns.map((design, i) => (
          <div className={classes.design} key={i}>
            {loadVisualization && (
              <div className={classes.loader}>
                <CircularProgress />
              </div>
            )}
            <div
              className={classes.image}
              style={{
                backgroundImage: `url(${getImageUrl(
                  viewImages[selectedDesignView.identifier][0].replace(
                    selectedDesign.toLowerCase(),
                    design.toLowerCase()
                  )
                )})`,
              }}
            />
            <Typography className={classes.titleLabel} variant="body2">
              {design.charAt(0) + design.slice(1, design.length).toLowerCase()}
            </Typography>
          </div>
        ))}
    </div>
  );
};

Designs.propTypes = {
  otherDesigns: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default Designs;
